// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Lazy from "../Control.Lazy/index.js";
import * as Control_Monad_Gen from "../Control.Monad.Gen/index.js";
import * as Control_Monad_Gen_Class from "../Control.Monad.Gen.Class/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Custom_Html from "../Custom.Html/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Gen from "../Data.String.Gen/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Lexeme from "../Lexeme/index.js";
import * as Matryoshka_Fold from "../Matryoshka.Fold/index.js";
import * as Matryoshka_Unfold from "../Matryoshka.Unfold/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_Token from "../Parsing.Token/index.js";
import * as Token from "../Token/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "argument";
    }
});
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "function";
    }
});
var ApplicationIsSymbol = {
    reflectSymbol: function () {
        return "Application";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "binder";
    }
});
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "body";
    }
});
var AbstractionIsSymbol = {
    reflectSymbol: function () {
        return "Abstraction";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString));
var genericShowConstructor1 = /* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "Variable";
    }
});
var ApplyFIsSymbol = {
    reflectSymbol: function () {
        return "ApplyF";
    }
};
var LambdaFIsSymbol = {
    reflectSymbol: function () {
        return "LambdaF";
    }
};
var genericShowConstructor2 = /* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "VariableF";
    }
});
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Array_NonEmpty_Internal.semigroupNonEmptyArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var bind = /* #__PURE__ */ Control_Bind.bind(Parsing.bindParserT);
var when = /* #__PURE__ */ Control_Applicative.when(Parsing.applicativeParserT);
var notEq = /* #__PURE__ */ Data_Eq.notEq(Lexeme.eqLexeme);
var show = /* #__PURE__ */ Data_Show.show(Lexeme.showLexeme);
var pure = /* #__PURE__ */ Control_Applicative.pure(Parsing.applicativeParserT);
var oneOf = /* #__PURE__ */ Data_Foldable.oneOf(Data_Foldable.foldableArray)(Parsing.plusParserT);
var map1 = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var some = /* #__PURE__ */ Data_Array_NonEmpty.some(Parsing.alternativeParserT)(Parsing.lazyParserT);
var apply = /* #__PURE__ */ Control_Apply.apply(Parsing.applyParserT);
var applyFirst = /* #__PURE__ */ Control_Apply.applyFirst(Parsing.applyParserT);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var over = /* #__PURE__ */ Data_Newtype.over()();
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM);
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var show1 = /* #__PURE__ */ Data_Show.show(Parsing.showParseError);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var tokens = /* #__PURE__ */ Token.tokens(Data_Identity.monadIdentity);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var ApplyF = /* #__PURE__ */ (function () {
    function ApplyF(value0) {
        this.value0 = value0;
    };
    ApplyF.create = function (value0) {
        return new ApplyF(value0);
    };
    return ApplyF;
})();
var LambdaF = /* #__PURE__ */ (function () {
    function LambdaF(value0) {
        this.value0 = value0;
    };
    LambdaF.create = function (value0) {
        return new LambdaF(value0);
    };
    return LambdaF;
})();
var VariableF = /* #__PURE__ */ (function () {
    function VariableF(value0) {
        this.value0 = value0;
    };
    VariableF.create = function (value0) {
        return new VariableF(value0);
    };
    return VariableF;
})();
var Application = /* #__PURE__ */ (function () {
    function Application(value0) {
        this.value0 = value0;
    };
    Application.create = function (value0) {
        return new Application(value0);
    };
    return Application;
})();
var Abstraction = /* #__PURE__ */ (function () {
    function Abstraction(value0) {
        this.value0 = value0;
    };
    Abstraction.create = function (value0) {
        return new Abstraction(value0);
    };
    return Abstraction;
})();
var Variable = /* #__PURE__ */ (function () {
    function Variable(value0) {
        this.value0 = value0;
    };
    Variable.create = function (value0) {
        return new Variable(value0);
    };
    return Variable;
})();
var ParserComponentState = function (x) {
    return x;
};
var Parse = /* #__PURE__ */ (function () {
    function Parse(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Parse.create = function (value0) {
        return function (value1) {
            return new Parse(value0, value1);
        };
    };
    return Parse;
})();
var genericParserQuery_ = {
    to: function (x) {
        return new Parse(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var genericExpr_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Application(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Abstraction(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Variable(x.value0.value0);
        };
        throw new Error("Failed pattern match at Expr (line 78, column 1 - line 78, column 31): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Application) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Abstraction) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Variable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Expr (line 78, column 1 - line 78, column 31): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericExpr_);
var showExpr = {
    show: function (e) {
        return genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil(showExpr))(showExpr))))(ApplicationIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons1(showRecordFieldsConsNil1(showExpr))(Data_Show.showString))))(AbstractionIsSymbol))(genericShowConstructor1)))(e);
    }
};
var genericExprF_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ApplyF(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new LambdaF(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new VariableF(x.value0.value0);
        };
        throw new Error("Failed pattern match at Expr (line 60, column 1 - line 60, column 36): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ApplyF) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof LambdaF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof VariableF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Expr (line 60, column 1 - line 60, column 36): " + [ x.constructor.name ]);
    }
};
var genericShow1 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericExprF_);
var showExprF = function (dictShow) {
    var genericShow2 = genericShow1(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil(dictShow))(dictShow))))(ApplyFIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons1(showRecordFieldsConsNil1(dictShow))(Data_Show.showString))))(LambdaFIsSymbol))(genericShowConstructor2)));
    return {
        show: function (e) {
            return genericShow2(e);
        }
    };
};
var functorExprF = {
    map: function (f) {
        return function (m) {
            if (m instanceof ApplyF) {
                return new ApplyF({
                    argument: f(m.value0.argument),
                    "function": f(m["value0"]["function"])
                });
            };
            if (m instanceof LambdaF) {
                return new LambdaF({
                    binder: m.value0.binder,
                    body: f(m.value0.body)
                });
            };
            if (m instanceof VariableF) {
                return new VariableF(m.value0);
            };
            throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var recursiveExprExprF = {
    project: function (v) {
        if (v instanceof Application) {
            return new ApplyF(v.value0);
        };
        if (v instanceof Abstraction) {
            return new LambdaF(v.value0);
        };
        if (v instanceof Variable) {
            return new VariableF(v.value0);
        };
        throw new Error("Failed pattern match at Expr (line 85, column 13 - line 88, column 30): " + [ v.constructor.name ]);
    },
    Functor0: function () {
        return functorExprF;
    }
};
var cata = /* #__PURE__ */ Matryoshka_Fold.cata(recursiveExprExprF);
var foldableExprF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof ApplyF) {
                    return f(f(z)(m.value0.argument))(m["value0"]["function"]);
                };
                if (m instanceof LambdaF) {
                    return f(z)(m.value0.body);
                };
                if (m instanceof VariableF) {
                    return z;
                };
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof ApplyF) {
                    return f(m.value0.argument)(f(m["value0"]["function"])(z));
                };
                if (m instanceof LambdaF) {
                    return f(m.value0.body)(z);
                };
                if (m instanceof VariableF) {
                    return z;
                };
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var mempty = Data_Monoid.mempty(dictMonoid);
        return function (f) {
            return function (m) {
                if (m instanceof ApplyF) {
                    return append3(f(m.value0.argument))(f(m["value0"]["function"]));
                };
                if (m instanceof LambdaF) {
                    return f(m.value0.body);
                };
                if (m instanceof VariableF) {
                    return mempty;
                };
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    }
};
var traversableExprF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = Control_Apply.apply(Apply0);
        var map2 = Data_Functor.map(Apply0.Functor0());
        var pure4 = Control_Applicative.pure(dictApplicative);
        return function (f) {
            return function (m) {
                if (m instanceof ApplyF) {
                    return apply1(map2(function (v1) {
                        return function (v2) {
                            return new ApplyF({
                                argument: v1,
                                "function": v2
                            });
                        };
                    })(f(m.value0.argument)))(f(m["value0"]["function"]));
                };
                if (m instanceof LambdaF) {
                    return map2(function (v1) {
                        return new LambdaF({
                            binder: m.value0.binder,
                            body: v1
                        });
                    })(f(m.value0.body));
                };
                if (m instanceof VariableF) {
                    return pure4(new VariableF(m.value0));
                };
                throw new Error("Failed pattern match at Expr (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(traversableExprF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return functorExprF;
    },
    Foldable1: function () {
        return foldableExprF;
    }
};
var eqExprF = function (dictEq) {
    var eq2 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof ApplyF && y instanceof ApplyF) {
                    return eq2(x.value0.argument)(y.value0.argument) && eq2(x["value0"]["function"])(y["value0"]["function"]);
                };
                if (x instanceof LambdaF && y instanceof LambdaF) {
                    return x.value0.binder === y.value0.binder && eq2(x.value0.body)(y.value0.body);
                };
                if (x instanceof VariableF && y instanceof VariableF) {
                    return x.value0 === y.value0;
                };
                return false;
            };
        }
    };
};
var eqExpr = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Application && y instanceof Application) {
                return Data_Eq.eq(eqExpr)(x.value0.argument)(y.value0.argument) && Data_Eq.eq(eqExpr)(x["value0"]["function"])(y["value0"]["function"]);
            };
            if (x instanceof Abstraction && y instanceof Abstraction) {
                return x.value0.binder === y.value0.binder && Data_Eq.eq(eqExpr)(x.value0.body)(y.value0.body);
            };
            if (x instanceof Variable && y instanceof Variable) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eq1 = /* #__PURE__ */ Data_Eq.eq(eqExpr);
var eq1ExprF = {
    eq1: function (dictEq) {
        return Data_Eq.eq(eqExprF(dictEq));
    }
};
var corecursiveExprExprF = {
    embed: function (v) {
        if (v instanceof ApplyF) {
            return new Application(v.value0);
        };
        if (v instanceof LambdaF) {
            return new Abstraction(v.value0);
        };
        if (v instanceof VariableF) {
            return new Variable(v.value0);
        };
        throw new Error("Failed pattern match at Expr (line 91, column 11 - line 94, column 30): " + [ v.constructor.name ]);
    },
    Functor0: function () {
        return functorExprF;
    }
};
var anaM = /* #__PURE__ */ Matryoshka_Unfold.anaM(corecursiveExprExprF);
var toLexemes = function (e) {
    var p = function (arr) {
        return Data_Array_NonEmpty.cons(Lexeme.OpenParen.value)(Data_Array_NonEmpty.snoc(arr)(Lexeme.CloseParen.value));
    };
    var lambda = function (l) {
        var arr = Data_Array_NonEmpty.cons(Lexeme.Lambda.value)(Data_Array_NonEmpty.cons(new Lexeme.Identifier(l.binder))(Data_Array_NonEmpty.cons(Lexeme.Dot.value)(l.body(new Data_Tuple.Tuple(true, true)))));
        return Data_Function["const"](function (v) {
            if (v) {
                return arr;
            };
            return p(arr);
        });
    };
    var apply1 = function (a) {
        return function (leading) {
            return function (trailing) {
                var f = a["function"](new Data_Tuple.Tuple(true, false));
                if (leading) {
                    return append(f)(a.argument(new Data_Tuple.Tuple(false, trailing)));
                };
                return p(append(f)(a.argument(new Data_Tuple.Tuple(false, true))));
            };
        };
    };
    var coalg = function (v) {
        if (v instanceof ApplyF) {
            return Data_Tuple.uncurry(apply1(v.value0));
        };
        if (v instanceof LambdaF) {
            return Data_Tuple.uncurry(lambda(v.value0));
        };
        if (v instanceof VariableF) {
            return Data_Function["const"](Data_Array_NonEmpty["cons$prime"](new Lexeme.Identifier(v.value0))([  ]));
        };
        throw new Error("Failed pattern match at Expr (line 173, column 11 - line 176, column 51): " + [ v.constructor.name ]);
    };
    return cata(coalg)(e)(new Data_Tuple.Tuple(true, true));
};
var render = /* #__PURE__ */ (function () {
    var multiApp = function (v) {
        if (v instanceof Application) {
            var $309 = multiApp(v["value0"]["function"]);
            return function ($310) {
                return $309((function (v1) {
                    return Data_Array.cons(v.value0.argument)(v1);
                })($310));
            };
        };
        return function (v1) {
            return Data_Array.cons(v)(v1);
        };
    };
    var coalg = function (v) {
        if (v instanceof Application) {
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("expr_application") ])([ Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("expr_application_root") ])([ Halogen_HTML_Core.text("@") ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("expr_application_leaves") ])(map(function ($311) {
                return Halogen_HTML_Core.widget(Data_Either.Left.create($311));
            })(multiApp(v["value0"]["function"])([ v.value0.argument ]))) ]);
        };
        if (v instanceof Abstraction) {
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("expr_abstraction") ])([ Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("expr_abstraction_root") ])([ Halogen_HTML_Core.text("\u03bb "), Halogen_HTML_Core.text(v.value0.binder) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("expr_abstraction_leaves") ])(map(function ($312) {
                return Halogen_HTML_Core.widget(Data_Either.Left.create($312));
            })(multiApp(v.value0.body)([  ]))) ]);
        };
        if (v instanceof Variable) {
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("expr_variable") ])([ Halogen_HTML_Core.text(v.value0) ]);
        };
        throw new Error("Failed pattern match at Expr (line 242, column 11 - line 263, column 72): " + [ v.constructor.name ]);
    };
    return Custom_Html.unfoldHTML(coalg);
})();
var print = /* #__PURE__ */ (function () {
    var $313 = Lexeme.printMany(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
    return function ($314) {
        return $313(toLexemes($314));
    };
})();
var ntParserComponentState = {
    Coercible0: function () {
        return undefined;
    }
};
var nextToken = /* #__PURE__ */ Parsing_Token.token(function (v) {
    return v.end;
});
var generator = function (dictMonadRec) {
    var genAlphaString = Data_String_Gen.genAlphaString(dictMonadRec);
    return function (dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        var map2 = Data_Functor.map(((Monad0.Bind1()).Apply0()).Functor0());
        var genAlphaString1 = genAlphaString(dictMonadGen);
        var pure4 = Control_Applicative.pure(Monad0.Applicative0());
        var oneOf1 = Control_Monad_Gen.oneOf(dictMonadGen)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
        var variable = map2(VariableF.create)(genAlphaString1);
        var coalg = function (sz) {
            var half = Data_Int.quot(sz)(2);
            var abstraction = map2(function (v) {
                return new LambdaF({
                    binder: v,
                    body: max(0)(sz - 1 | 0)
                });
            })(genAlphaString1);
            var small = Data_Array_NonEmpty["cons$prime"](abstraction)([ variable ]);
            var large = Data_Array_NonEmpty.cons(pure4(new ApplyF({
                "function": half,
                argument: half
            })))(small);
            var $289 = sz <= 0;
            if ($289) {
                return variable;
            };
            return oneOf1((function () {
                var $290 = sz <= 1;
                if ($290) {
                    return small;
                };
                return large;
            })());
        };
        return Control_Monad_Gen_Class.sized(dictMonadGen)(anaM(Monad0)(traversableExprF)(coalg));
    };
};
var expr = function (e) {
    var lexeme = function (l) {
        return Parsing_Combinators["try"](bind(nextToken)(function (v) {
            return when(notEq(v.lexeme)(l))(Parsing.fail("Expected " + show(l)));
        }));
    };
    var openParen = lexeme(Lexeme.OpenParen.value);
    var lambda = lexeme(Lexeme.Lambda.value);
    var identifier = Parsing_Combinators["try"](bind(nextToken)(function (v) {
        if (v.lexeme instanceof Lexeme.Identifier) {
            return pure(v.lexeme.value0);
        };
        return Parsing.fail("Expected an identifier");
    }));
    var dot = lexeme(Lexeme.Dot.value);
    var closeParen = lexeme(Lexeme.CloseParen.value);
    var atom = oneOf([ map1(Variable.create)(identifier), Parsing_Combinators.between(openParen)(closeParen)(e), Parsing.fail("Expected an atom (identifier or parenthesized expression)") ]);
    var app = bind(some(Parsing_Combinators["try"](atom)))(function (fs) {
        var i = Data_Array_NonEmpty.foldl1(function ($$function) {
            return function (argument) {
                return new Application({
                    "function": $$function,
                    argument: argument
                });
            };
        })(fs);
        return bind(Parsing_Combinators.optionMaybe(Parsing_Combinators["try"](e)))(function (t) {
            return pure((function () {
                if (t instanceof Data_Maybe.Nothing) {
                    return i;
                };
                if (t instanceof Data_Maybe.Just) {
                    return new Application({
                        "function": i,
                        argument: t.value0
                    });
                };
                throw new Error("Failed pattern match at Expr (line 133, column 12 - line 135, column 57): " + [ t.constructor.name ]);
            })());
        });
    });
    var abs = apply(apply(apply(map1(function (v) {
        return function (v1) {
            return function (v2) {
                return function (v3) {
                    return new Abstraction({
                        binder: v1,
                        body: v3
                    });
                };
            };
        };
    })(lambda))(identifier))(dot))(e);
    return oneOf([ abs, app, Parsing.fail("Expected lambda, application, or identifier") ]);
};
var expression = /* #__PURE__ */ Control_Lazy.fix(Parsing.lazyParserT)(expr);
var parseQuery = function (v) {
    var v1 = Parsing.runParser(v.value0)(applyFirst(expression)(Parsing_Combinators.notFollowedBy(nextToken)));
    if (v1 instanceof Data_Either.Left) {
        return discard(modify_(over(ParserComponentState)(function (v2) {
            return {
                lastExpression: v2.lastExpression,
                parseError: new Data_Maybe.Just(v1.value0)
            };
        })))(function () {
            return pure1(Data_Maybe.Nothing.value);
        });
    };
    if (v1 instanceof Data_Either.Right) {
        return discard(put({
            parseError: Data_Maybe.Nothing.value,
            lastExpression: new Data_Maybe.Just(v1.value0)
        }))(function () {
            return pure1(new Data_Maybe.Just(v.value1(v1.value0)));
        });
    };
    throw new Error("Failed pattern match at Expr (line 205, column 3 - line 211, column 31): " + [ v1.constructor.name ]);
};
var parserComponent = /* #__PURE__ */ (function () {
    var renderComponent = function (v) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("parser") ])(append2(Data_Maybe.maybe([  ])(function (pe) {
            return pure2(Custom_Html.overlay([ "parser_error" ])([ Halogen_HTML_Core.text(show1(pe)) ]));
        })(v.parseError))(Data_Maybe.maybe([  ])(function (ex) {
            return pure2(render(ex));
        })(v.lastExpression)));
    };
    return Halogen_Component.mkComponent({
        initialState: Data_Function["const"]({
            parseError: Data_Maybe.Nothing.value,
            lastExpression: Data_Maybe.Nothing.value
        }),
        render: renderComponent,
        "eval": Halogen_Component.mkEval({
            initialize: Data_Maybe.Nothing.value,
            receive: Data_Function["const"](Data_Maybe.Nothing.value),
            handleAction: Data_Function["const"](pure1(Data_Unit.unit)),
            handleQuery: parseQuery,
            finalize: Data_Maybe.Nothing.value
        })
    });
})();
var checkPrintParse = function (x) {
    var rt = bind1(Parsing.runParser(print(x))(tokens(Lexeme.parser)))(function (toks) {
        return bind1(Parsing.runParser(toks)(expression))(function (y) {
            return pure3(eq1(x)(y));
        });
    });
    if (rt instanceof Data_Either.Left) {
        return false;
    };
    if (rt instanceof Data_Either.Right) {
        return rt.value0;
    };
    throw new Error("Failed pattern match at Expr (line 182, column 21 - line 184, column 15): " + [ rt.constructor.name ]);
};
export {
    ApplyF,
    LambdaF,
    VariableF,
    Application,
    Abstraction,
    Variable,
    generator,
    expression,
    toLexemes,
    print,
    checkPrintParse,
    Parse,
    parserComponent,
    render,
    genericExprF_,
    eq1ExprF,
    eqExprF,
    functorExprF,
    foldableExprF,
    traversableExprF,
    showExprF,
    genericExpr_,
    eqExpr,
    showExpr,
    recursiveExprExprF,
    corecursiveExprExprF,
    genericParserQuery_
};
//# sourceMappingURL=index.js.map
